<template>
  <div>
    <nuxt-loading-indicator
      :height="4"
      color="var(--color-accent-1)" />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <ADialogs />
    <umbraco-tools />
  </div>
</template>

<script setup lang="ts">
</script>

<style>
:root:root {
  --container-margin: 0 auto;
  --container-max-width: 1300px;
}
</style>
